import React, { useEffect, useRef } from "react";
 import { useDispatch, useSelector } from "react-redux";
 import {
   setCurrentRoute,
 } from "../../redux/features/loginSlice";
 import Cookies from 'js-cookie';
 import { useLogout } from "../../utils/useLogout";
 import { configureStoreFn } from '../../redux/store';
 import { useNavigate } from "react-router-dom";
 function TryAgain() {
   const login = useSelector((state) => state.login);
   const count = useRef(false);
   const { user } = useSelector((state) => state.accountManage);
   const dispatch = useDispatch();
   let navigate = useNavigate();
   const { store,persister } = configureStoreFn();
   useEffect(() => {
     dispatch(setCurrentRoute(`/account`));
   }, []);
 
   const { logout: globalLogout, ssoFlagStatus } = useLogout();
 
   const clearReduxStorage = () => {
     persister.purge(); // clear persisted state
     store.dispatch({ type: 'login/ResetLoginData' }); // reset in-memory state
   };
 
   const logout = () => {
     globalLogout();
     const ssoF = user?.ssoFlag ? true : false;
     count.current = Boolean(ssoF);
   };
 
 
  const refreshCacheAndReload = () => {
     if (caches) {
       caches.keys().then((names) => {
         names.forEach((name) => {
           caches.delete(name);
         });
       });
     }
   };
 
  const deleteAllCookies = () => {
     const allCookies = Cookies.get();
     for (const cookieName in allCookies) {
       Cookies.remove(cookieName);
     }
   };
 
 
   const hardRefresh=()=>{
     refreshCacheAndReload();
     localStorage.clear();
     deleteAllCookies();
     logout();
     clearReduxStorage();
     navigate("/");
     window.location.reload();
    
   }
 
   return (
     <div style={{marginTop:20,width:200}}>
      <button
           onClick={()=>{hardRefresh()}}
           className="btn-primary text-center wide"
         >
           Try again
         </button>
     </div>
   );
 }
 
 export default TryAgain;

